import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';
import {CommonService} from '../../../../../../../core/services/common.service';
import {Message} from '../../../../../../../core/class/message';
import {DocumentService} from '../../../../../../../core/services/document.service';
import {WarningComponent} from '../../../../../../../shared/components/warning/warning.component';

@Component({
  selector: 'app-setup-sign-flow-lot-view',
  templateUrl: './setup-sign-flow-lot-view.component.html',
  styleUrls: ['./setup-sign-flow-lot-view.component.scss']
})
export class SetupSignFlowLotViewComponent implements OnInit, OnDestroy {
  contracts: any[] = [];
  listData: any[] = [];
  listDataPopup: any[] = [];
  paginate: {
    currentPage: number;
    pageSize: number;
    totalRow: number;
    totalPage: number;
    totalPageArray: any;
    no: any;
  };
  page = 0;
  pageSize = 10;
  lotId: string;
  pollTimer: any;
  isProcess = false;
  isStop = false;

  displayedColumns: string[] = [
    'STT',
    'contractName',
    'result',
    'detail',
  ];

  constructor(
    public dialogRef: MatDialogRef<SetupSignFlowLotViewComponent>,
    private commonService: CommonService,
    private message: Message,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.contracts = (data && data.contracts) || [];
    this.listDataPopup = this.contracts.map(c => ({...c, status: 'PROCESSING'}));
    this.lotId = (data && data.lotId) || null;
    dialogRef.disableClose = true;
    this.paginate = {
      currentPage: this.page,
      pageSize: this.pageSize,
      totalRow: this.listDataPopup.length,
      totalPage: Math.ceil(this.listDataPopup.length / this.pageSize),
      totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / this.pageSize), 1),
      no: this.counter(this.pageSize, this.page * this.pageSize + 1)
    };
    this.onFilterData(this.page, this.pageSize);
  }

  ngOnInit() {
    if (this.lotId) {
      this.startPolling();
    }
  }

  ngOnDestroy() {
    this.stopPolling();
  }

  startPolling() {
    this.isProcess = true;
    this.pollLot();
    this.pollTimer = setInterval(() => this.pollLot(), 3000);
  }

  stopPolling() {
    this.isProcess = false;
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }

  onClickStop() {
    const popup = this.dialog.open(WarningComponent, {
      width: '30%',
      data: 'messages.sign_multi_stop_confirm'
    });

    popup.afterClosed().subscribe(rs => {
      if (rs) {
        this.documentService.signContractFlowCancel(this.lotId).subscribe(res => {
          if (res && res.success) {
            this.isStop = true;
            this.stopPolling();
            this.toastr.success(this.message.getMessage('messages.sign_multi_stop'));
          } else {
            this.toastr.error(this.message.getMessage('messages.sign_multi_stop_fail'));
          }
        });
      }
    });
  }

  pollLot() {
    this.documentService.signContractFlowInfo(this.lotId).subscribe(res => {
      if (!res || !res.data || !res.data.lotDetails) {
        return;
      }
      this.listDataPopup = res.data.lotDetails.map(e => ({...e, order: e.orderNo}));
      this.onFilterData(this.page, this.pageSize);
      const allDone = this.listDataPopup.length > 0 && this.listDataPopup.every(e => e.status === 'done' || e.status === 'DONE');
      const anyError = this.listDataPopup.some(e => e.status === 'error' || e.status === 'ERROR');
      const anyCancel = this.listDataPopup.some(e => e.status === 'cancel' || e.status === 'CANCEL');
      if (allDone || anyError || anyCancel) {
        this.stopPolling();
      }
    });
  }

  onFilterData(page: number = 0, pageSize: number = 10) {
    this.page = page;
    this.pageSize = pageSize;
    this.listData = [];
    const start = page * pageSize;
    this.listDataPopup.forEach((ele, i) => {
      if (start <= i && i < start + pageSize) {
        this.listData.push(ele);
      }
      ele.order = i + 1;
    });
    this.paginate = {
      currentPage: page,
      pageSize: pageSize,
      totalRow: this.listDataPopup.length,
      totalPage: Math.ceil(this.listDataPopup.length / pageSize),
      totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / pageSize), 1),
      no: this.counter(pageSize, page * pageSize + 1)
    };
  }

  counter(index: number, from: number) {
    return new Array(index).fill(0).map((x, i: number) => i + from);
  }

  get countText(): string {
    return this.commonService.format(
      this.message.getMessage('enterprise_contract.lot_setup_sign_flow_count'),
      [this.listDataPopup.length]
    );
  }

  renderStatus(status: string): string {
    switch (status) {
      case 'error':
      case 'ERROR':
        return this.message.getMessage('sign_contract_flow.error');
      case 'PROCESSING':
        return this.message.getMessage('sign_contract_flow.processing');
      case 'CANCEL':
      case 'cancel':
        return this.message.getMessage('sign_contract_flow.cancel');
      case 'done':
      case 'DONE':
        return this.message.getMessage('sign_contract_flow.success');
      default:
        return '';
    }
  }

  renderStatusColor(status: string): object {
    switch (status) {
      case 'error':
      case 'ERROR':
        return {'color': 'red', 'border': '1px solid red', 'border-radius': '5px'};
      case 'PROCESSING':
        return {'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px'};
      case 'CANCEL':
      case 'cancel':
        return {'color': 'gray', 'border': '1px solid gray', 'border-radius': '5px'};
      case 'done':
      case 'DONE':
        return {'color': 'green', 'border': '1px solid green', 'border-radius': '5px'};
      default:
        return {};
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
